import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import { createBrowserHistory } from 'history';
import { Provider } from 'react-redux';
import { AppContainer } from 'react-hot-loader';
import 'typeface-roboto';

import App from './App';
import registerServiceWorker from './registerServiceWorker';
import configureStore from './configureStore';

const history = createBrowserHistory();
const store = configureStore(history);
const theme = createMuiTheme({
  typography: {
    useNextVariants: true,
  },
});

const render = () => {
  ReactDOM.render(
    <AppContainer>
      <MuiThemeProvider theme={theme}>
        <Provider store={store}>
          <App history={history} />
        </Provider>
      </MuiThemeProvider>
    </AppContainer>,
    document.getElementById('root') as HTMLElement,
  );
};

render();
registerServiceWorker();

if (module.hot) {
  module.hot.accept('./App', () => {
    render();
  });
}



// WEBPACK FOOTER //
// ./src/index.tsx